// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ucnhdfhchlicvlzooenz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVjbmhkZmhjaGxpY3Zsem9vZW56Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgwOTQ1NDAsImV4cCI6MjA3MzY3MDU0MH0.UwDtkrs79MqSDYiI4g-HroAWmDIgnkuD6e5Rk-KkWXg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});